import { saveAPIKey, getAPIKey } from './apiKeyUtils';

/**
 * Migration utility to ensure API keys are stored in the correct format
 * This fixes legacy storage issues where keys might be in different formats
 */
export function migrateAPIKeys(): void {
  try {
    // All possible legacy storage formats
    const openaiSources = [
      'openai_token',
      'openai_api_key', 
      'email_provider_openai'
    ];
    
    const perplexitySources = [
      'perplexity_token',
      'perplexity_api_key',
      'email_provider_perplexity'
    ];

    // Check for provider objects
    const openaiProvider = localStorage.getItem('openai_provider');
    const perplexityProvider = localStorage.getItem('perplexity_provider');

    // Migrate OpenAI key
    let openaiKey = '';
    for (const source of openaiSources) {
      const key = localStorage.getItem(source);
      if (key) {
        openaiKey = key;
        break;
      }
    }
    
    // Check provider object for OpenAI key
    if (!openaiKey && openaiProvider) {
      try {
        const provider = JSON.parse(openaiProvider);
        if (provider.apiKey) {
          openaiKey = provider.apiKey;
        }
      } catch (e) {
        console.warn('Failed to parse openai_provider object');
      }
    }

    if (openaiKey) {
      saveAPIKey('openai', openaiKey);
      console.log('OpenAI API key migration completed');
    }

    // Migrate Perplexity key  
    let perplexityKey = '';
    for (const source of perplexitySources) {
      const key = localStorage.getItem(source);
      if (key) {
        perplexityKey = key;
        break;
      }
    }
    
    // Check provider object for Perplexity key
    if (!perplexityKey && perplexityProvider) {
      try {
        const provider = JSON.parse(perplexityProvider);
        if (provider.apiKey) {
          perplexityKey = provider.apiKey;
        }
      } catch (e) {
        console.warn('Failed to parse perplexity_provider object');
      }
    }

    if (perplexityKey) {
      saveAPIKey('perplexity', perplexityKey);
      console.log('Perplexity API key migration completed');
    }

  } catch (error) {
    console.error('Error during API key migration:', error);
  }
}

/**
 * Check if API keys are properly configured for enrichment
 */
export function validateAPIKeySetup(): { openai: boolean; perplexity: boolean } {
  const openaiKey = getAPIKey('openai');
  const perplexityKey = getAPIKey('perplexity');
  
  return {
    openai: !!openaiKey && openaiKey.length > 0,
    perplexity: !!perplexityKey && perplexityKey.length > 0
  };
}